<div class="expired-studies">

  <div *ngIf="historicalShares.length === 0" class="empty-state">
    <mat-icon class="empty-icon">check_circle</mat-icon>
    <span>No expired studies on record.</span>
  </div>

  <div class="share-list" *ngIf="historicalShares.length > 0">
    <div *ngFor="let share of historicalShares" class="share-card">

      <!-- Header row: metadata + status chip -->
      <div class="share-card__header">
        <div class="share-card__meta">
          <span class="share-card__patient">
            {{ share.patient_name || share.case_name }}
            <span *ngIf="share.patient_id" class="share-card__patient-id"> · {{ share.patient_id }}</span>
          </span>
          <span class="share-card__study-meta">
            <span *ngIf="share.study_date">{{ share.study_date }}</span>
            <span *ngIf="share.study_date && share.accession_number"> · </span>
            <span *ngIf="share.accession_number">Acc: {{ share.accession_number }}</span>
            <span *ngIf="(share.study_date || share.accession_number) && (share.num_series != null)"> · </span>
            <span *ngIf="share.num_series != null">{{ share.num_series }}/{{ share.num_instances ?? '?' }} ser/inst</span>
          </span>
          <span class="share-card__facility">From: {{ share.shared_by_facility_id }}</span>
          <span class="share-card__dates">
            Shared {{ formatDate(share.shared_at) }}
            <span *ngIf="share.expired_at || share.effective_expires_at">
              · Expired {{ formatExpiredAt(share) }}
            </span>
          </span>
        </div>
        <span class="status-chip" [class]="statusClass(share)">{{ statusLabel(share) }}</span>
      </div>

      <!-- Approved state: explicit messaging -->
      <div *ngIf="share.status === 'reshared'" class="reshared-notice">
        <mat-icon class="reshared-notice__icon">check_circle</mat-icon>
        <div class="reshared-notice__text">
          <div class="reshared-notice__title">Approved — waiting for Hub to re-share</div>
          <div class="reshared-notice__subtitle">Access will return once the Hub shares the study again.</div>
        </div>
      </div>

      <!-- Actions row -->
      <div class="share-card__actions">

        <!-- Request re-share button (expired / deleted / rejection terminal states) -->
        <button
          *ngIf="canRequestReshare(share)"
          mat-stroked-button
          color="primary"
          class="reshare-button"
          [disabled]="pendingRequestIds.has(share.id)"
          (click)="onRequestReshare(share)">
          <mat-progress-spinner
            *ngIf="pendingRequestIds.has(share.id)"
            diameter="16"
            mode="indeterminate"
            class="button-spinner">
          </mat-progress-spinner>
          <mat-icon *ngIf="!pendingRequestIds.has(share.id)">refresh</mat-icon>
          <span>Request re-share</span>
        </button>

        <!-- Pending state indicator (not a button) -->
        <span *ngIf="share.status === 're_requested'" class="pending-state">
          <mat-icon class="pending-state__icon">schedule</mat-icon>
          <span>Re-share request pending</span>
        </span>

        <!-- View details toggle -->
        <button mat-button class="details-button" (click)="toggleDetails(share.id)">
          <mat-icon>{{ expandedShareId === share.id ? 'expand_less' : 'info_outline' }}</mat-icon>
          {{ expandedShareId === share.id ? 'Hide details' : 'View details' }}
        </button>

      </div>

      <!-- Expandable metadata details (no DICOM access) -->
      <div *ngIf="expandedShareId === share.id" class="share-card__details">
        <div class="detail-row">
          <span class="detail-label">Study UID</span>
          <span class="detail-value mono">{{ share.study_instance_uid }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Patient Ref</span>
          <span class="detail-value">{{ share.case_name }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Sent by</span>
          <span class="detail-value">{{ share.shared_by_facility_id }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Shared on</span>
          <span class="detail-value">{{ formatDate(share.shared_at) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Expired on</span>
          <span class="detail-value">{{ formatExpiredAt(share) }}</span>
        </div>
        <div class="detail-row" *ngIf="share.re_request_sent_at">
          <span class="detail-label">Requested on</span>
          <span class="detail-value">{{ formatDate(share.re_request_sent_at) }}</span>
        </div>
        <div class="detail-row" *ngIf="share.re_request_count > 0">
          <span class="detail-label">Request count</span>
          <span class="detail-value">{{ share.re_request_count }}</span>
        </div>
      </div>

    </div>
  </div>
</div>
